var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"1000px","margin-right":"20px"}},[_c('cTable',{ref:"table",attrs:{"fields":_vm.fields,"config":_vm.config,"footer":_vm.footer}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }